const SLIDES = [
  {
    src: "https://images.unsplash.com/photo-1651340675491-6fb0bfb5c4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjaXJjdWl0JTIwYm9hcmQlMjBtaWNyb3Njb3BlfGVufDB8fHx8MTc5MTk3MDgwNXww&ixlib=rb-4.1.0&q=85",
    label: "01 / Micro-Soudure",
    alt: "Microscope de banc inspectant les pistes d'une carte de calculateur",
  },
  {
    src: "https://images.unsplash.com/photo-1687038520579-8d8f24721267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxlbGVjdHJvbmljJTIwd2lyaW5nJTIwY2FibGVzfGVufDB8fHx8MTc5MTk3MDgwNXww&ixlib=rb-4.1.0&q=85",
    label: "02 / Diagnostic Banc",
    alt: "Câbles de pinout et adaptateurs boot-mode connectés",
  },
  {
    src: "https://images.unsplash.com/photo-1771189956777-575006b6b145?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxjb21wdXRlciUyMG1pY3JvY2hpcCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzkxOTcwODA1fDA&ixlib=rb-4.1.0&q=85",
    label: "03 / Clonage EEPROM",
    alt: "Programmeur spécialisé lisant une puce EEPROM",
  },
  {
    src: "https://images.unsplash.com/photo-1577705998148-6da4f3963bc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxzaGlwcGluZyUyMHBhY2thZ2UlMjBib3h8ZW58MHx8fHwxNzkxOTcwODA1fDA&ixlib=rb-4.1.0&q=85",
    label: "04 / Envoi Sécurisé",
    alt: "Colis sécurisé antistatique prêt pour l'expédition",
  },
];

export const PhotoStrip = () => (
  <section className="py-12 border-b border-[#1C2C4E] bg-[#06101F]">
    <div className="max-w-6xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-4">
      {SLIDES.map((s) => (
        <div key={s.label} className="relative h-44 rounded border border-[#1C2C4E] overflow-hidden">
          <img src={s.src} alt={s.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
          <span className="absolute bottom-2 left-3 font-mono text-[10px] uppercase tracking-widest text-slate-300">{s.label}</span>
        </div>
      ))}
    </div>
  </section>
);
